/**
 * Generates 5 picture-based math questions from the payload
 * @param {Object} payload - The payload from NumberOperationsTemplate
 * @returns {Array} Array of question objects
 */
function generatePicOpsQuestions(payload) {
    const { selectedEmojis, operationType, numberRange } = payload.options;
    
    // Parse number range
    const [min, max] = numberRange.split('-').map(Number);
    
    // Helper function to get random number within range
    const getRandomNumber = (minNum, maxNum) => {
      return Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum;
    };
    
    // Helper function to get random emoji
    const getRandomEmoji = () => {
      return selectedEmojis[Math.floor(Math.random() * selectedEmojis.length)];
    };
    
    // Generate addition question
    const generateAddition = () => {
      const num1 = getRandomNumber(min, max);
      const num2 = getRandomNumber(min, max);
      const answer = num1 + num2;
      
      // Ensure sum doesn't get too large (optional constraint)
      if (answer > max * 2) {
        return generateAddition(); // Retry if sum is too large
      }
      
      return {
        type: 'addition',
        num1,
        num2,
        answer,
        emoji1: getRandomEmoji(),
        operation: '+',
        display: `${num1} + ${num2} = ?`,
        pictureDisplay: `[${num1} ${getRandomEmoji()}s] + [${num2} ${getRandomEmoji()}s] = ?`
      };
    };
    
    // Generate subtraction question
    const generateSubtraction = () => {
      let num1 = getRandomNumber(min, max);
      let num2 = getRandomNumber(min, max);
      
      // Ensure num1 >= num2 for positive result
      if (num1 < num2) {
        [num1, num2] = [num2, num1]; // Swap numbers
      }
      
      // Avoid trivial subtractions like n - n = 0
      if (num1 === num2 && num1 > min) {
        num2 = getRandomNumber(min, num1 - 1);
      }
      
      const answer = num1 - num2;
      
      return {
        type: 'subtraction',
        num1,
        num2,
        answer,
        emoji1: getRandomEmoji(),
        operation: '-',
        display: `${num1} - ${num2} = ?`,
      };
    };
    
    // Determine question types based on operationType
    let questionTypes = [];
    
    switch (operationType) {
      case 'addition':
        questionTypes = ['addition', 'addition', 'addition', 'addition', 'addition'];
        break;
      case 'subtraction':
        questionTypes = ['subtraction', 'subtraction', 'subtraction', 'subtraction', 'subtraction'];
        break;
      case 'mixed':
        // Generate mix of addition and subtraction (3 addition, 2 subtraction or vice versa)
        questionTypes = ['addition', 'addition', 'addition', 'subtraction', 'subtraction'];
        // Shuffle the array for random order
        for (let i = questionTypes.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [questionTypes[i], questionTypes[j]] = [questionTypes[j], questionTypes[i]];
        }
        break;
      default:
        break;
    }
    
    // Generate all questions
    const questions = questionTypes.map((type, index) => {
      let question;
      
      if (type === 'addition') {
        question = generateAddition();
      } else {
        question = generateSubtraction();
      }
      
      return {
        ...question,
        questionNumber: index + 1,
        id: `q${index + 1}`
      };
    });
    
    // Add worksheet metadata
    return {
      questions,
      // metadata: {
      //   totalQuestions: 5,
      //   operationType,
      //   numberRange,
      //   selectedEmojis,
      //   showAnswers,
      //   difficulty: getDifficultyLevel(numberRange),
      //   generatedAt: new Date().toISOString()
      // }
    };
  }
  
  export default generatePicOpsQuestions;